import styled from 'styled-components';
import { MID_GREY, VL_BLACK, WHITE } from '../../utils/colours';

import { ButtonsRow } from '../layout';

// In px
const closeButtonSize = 20;
const closeButtonMargin = 10;

// Wrapper

export const ModalContainer = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    ${({ $fullSize }) => $fullSize ? `
        height: 100vh;
        height: 100dvh;
    ` : ''}
    background-color: ${({ $fullSize }) => VL_BLACK($fullSize ? 95 : 75)};
    top: 0;
    left: 0;
    z-index: ${({ $zIndex }) => $zIndex};
    justify-content: center;
    align-items: center;
    display: ${({ show }) => (show ? 'flex' : 'none')};
`;

ModalContainer.displayName = 'ModalContainer';


export const ClickBuffer = styled.div`
    display: contents;
`;

ClickBuffer.displayName = 'ClickBuffer';

// Card

export const ModalHeading = styled.h3`
    font-weight: 300;
    margin-top: 0;
    color: ${VL_BLACK()};
`;

ModalHeading.displayName = 'ModalHeading';


export const ModalBody = styled.div`
    height: 100%;
`;

ModalBody.displayName = 'ModalBody';


export const ModalButtons = styled(ButtonsRow).attrs({
    centre: true
})`
    position: relative;

    ${({ $hasButtonLeft }) =>
        $hasButtonLeft
            ? `
                > :first-child:not(:last-child) {
                    position: absolute;
                    top: 0;
                    left: 0;
                }
            `
            : ''}

    @media screen and (max-width: 600px) {
        ${({ $hasButtonLeft }) =>
            $hasButtonLeft
                ? `
                    > :first-child:not(:last-child) {
                        position: static;
                        top: auto;
                        left: auto;
                        margin-left: 0;
                    }
                `
                : ''}

        ${({ $buttonLeftMobileLayout }) =>
            $buttonLeftMobileLayout === 'split'
                ? `
                    align-items: center;
                    flex-wrap: nowrap;
                    justify-content: space-between;
                `
                : ''}

        ${({ $buttonLeftMobileLayout }) =>
            $buttonLeftMobileLayout === 'stacked-center'
                ? `
                    justify-content: center;

                    > :first-child:not(:last-child) {
                        display: flex;
                        flex: 0 0 100%;
                        justify-content: center;
                    }
                `
                : ''}
    }
`;

ModalButtons.displayName = 'ModalButtons';


export const CloseButton = styled.button`
    height: ${closeButtonSize}px;
    min-height: ${closeButtonSize}px;
    min-width: ${closeButtonSize}px;
    width: ${closeButtonSize}px;
    background: ${WHITE()};
    border: 1px solid ${MID_GREY};
    border-radius: 30px;
    cursor: pointer;
    margin-left: auto;
    color: ${VL_BLACK()};

    display: flex;
    justify-content: center;
    align-items: center;

    svg {
        min-height: ${closeButtonSize - 12}px;
        min-width: ${closeButtonSize - 12}px;
    }
`;

CloseButton.displayName = 'CloseButton';


export const ModalCard = styled.div`
    /** light background modals: reset font smoothing for subpixel/user preffered antialiasing */
    ${({ $dark }) => $dark ? '' : `
        -webkit-font-smoothing: auto;
        -moz-osx-font-smoothing: auto;
        text-rendering: auto;
    `}
    background: ${({ $dark }) => $dark ? VL_BLACK() : WHITE()};
    color: ${({ $dark }) => $dark ? WHITE() : VL_BLACK()};

    ${'' /* background: ${({ $fullSize }) => $fullSize ? 'transparent' : LIGHT_GREY};
    color: ${({ $fullSize }) => $fullSize ? WHITE() : VL_BLACK()}; */}
    border-radius: 5px;
    max-width: ${({ $wide, $fullSize }) => $fullSize ? '100%' : $wide ? '90%' : 'min(700px, 90%)'};
    min-width: min(max(35%, 300px), 550px);
    max-height: 90%;
    ${({ $fullSize }) =>  $fullSize ? `
        width: 100%;
        height: 100vh;
        height: 100dvh;
        max-height: 100vh;
        max-height: 100dvh;
    ` : ''}
    padding: ${({ $fullSize }) => $fullSize ? `
        calc(${closeButtonMargin}px + env(safe-area-inset-top))
        calc(${closeButtonMargin}px + env(safe-area-inset-right))
        calc(${closeButtonMargin}px + env(safe-area-inset-bottom))
        calc(${closeButtonMargin}px + env(safe-area-inset-left))
    ` : `${closeButtonMargin}px`};
    box-shadow: ${({ $fullSize }) => $fullSize ? 'none' : '0 5px 15px rgba(0, 0, 0, 0.5)'};
    position: relative;
    overflow-y: ${({ $overflowVisible }) => $overflowVisible ? 'visible' : 'auto'};
    text-align: ${({ leftAlign }) => (leftAlign ? 'left' : 'center')};
    
    /* Left align Modal.Buttons too */
    ${ModalButtons} {
        ${({ leftAlign }) => leftAlign ? 'justify-content: flex-start;' : ''}
    }

    display: flex;
    flex-direction: column;
    gap: ${closeButtonMargin}px;

    a {
        color: ${({ accentColour }) => accentColour};
    }

    h1,h2,h3,h4,h5,h6 {
        color: ${VL_BLACK()};
    }
`;

ModalCard.displayName = 'ModalCard';


export const ModalCardContents = styled.div`
    overflow-y: ${({ $overflowVisible }) => $overflowVisible ? 'visible' : 'auto'};
    padding: 0 15px 15px;

    // Fill space if consistent height put on ModalCard
    flex-grow: 1;

    // Add this for fullSize mode to ensure height is available for percentage-based children
    ${({ $fullSize }) => $fullSize ? `
        display: flex;
        flex-direction: column;
        min-height: 0; /* Critical: allows flex child to shrink below content size */
        height: 100%; /* Make height explicit for percentage-based children */
    ` : ''}
`;

ModalCardContents.displayName = 'ModalCardContents';
